import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";
import { DisplayListUI } from "@/Common/Components/Collections/DisplayListUI";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { Person } from "@/Common/Models/Person/Person";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IClickableTextUsersComponentPopupProps {
    allClickableTabNames: string[];
    textListCallback: (textList: SearchableItemModelT<ClickableTextItem>) => void;
    selectAllTabsCallBack: (tabs: ClickableTextItem[]) => void;
    newClickableTabItems?: ClickableTextItem[];
    allListOfClickableText: ClickableTextItem[];
    allUsers?: Person[];
    allGroups?: EmployeeGroup[];
    isGroupMode?: boolean;
}

class ClickableTextUsersComponentState {
    public users: SearchableItemModelT<Person>[];
    public groups: SearchableItemModelT<EmployeeGroup>[];
    public textList: SearchableItemModelT<ClickableTextItem>[];
    public clickableContent: string[];
    public isShowDetails: boolean;
}

class ClickableTextUsersComponent extends React.Component<IClickableTextUsersComponentPopupProps, ClickableTextUsersComponentState> {
    constructor(props: IClickableTextUsersComponentPopupProps) {
        super(props);

        const initialState = new ClickableTextUsersComponentState();
        initialState.clickableContent = [];
        initialState.users = props.allUsers != null ? props.allUsers.map(x => new SearchableItemModelT<Person>(x.NameWithPrefix, null, x, x.NameWithPrefix + " " + x.Name + " " + x.FirstName + " " + x.LastName)) : [];
        initialState.groups = props.allGroups != null ? props.allGroups.map(x => new SearchableItemModelT<EmployeeGroup>(x.Name, x.Id, x, x.Name)) : [];
        initialState.textList = (props.allListOfClickableText && props.allListOfClickableText.length > 0) ? props.allListOfClickableText.map(x => new SearchableItemModelT<ClickableTextItem>(x.TabName, x.ItemId, x, x.TabName)) : [];
        initialState.isShowDetails = false;
        this.state = initialState;
    }

    public componentDidUpdate(prevProps: IClickableTextUsersComponentPopupProps): void {
        if (this.props.allListOfClickableText != prevProps.allListOfClickableText)
            this.mutateState(
                s => {
                    s.textList = this.props.allListOfClickableText != null ? this.props.allListOfClickableText.map(x => new SearchableItemModelT<ClickableTextItem>(x.TabName, x.ItemId, x, x.TabName)) : [];
                    s.clickableContent = [];
                },
                () => this.props.selectAllTabsCallBack(this.props.allListOfClickableText)
            );
    }

    public componentWillUnmount(): void {
        let self = this;
        self.props.selectAllTabsCallBack([]);
    }

    public render(): JSX.Element {
        let self = this;

        return (
            <div>
                {/* employees */}
                <div className="tab-content-clickableText">

                    <div style={{ width: "25%", float: "left", height: "415px" }}>
                        <div style={{ textAlign: "center", padding: "5px 0px", borderBottom: " solid 1px rgb(214, 209, 209)" }}>
                            <h5>{(this.props.isGroupMode) ? cacheStore.GetString("GroupLabel") : cacheStore.GetString("EmployeeLabel")}</h5>
                        </div>
                        {!self.props.isGroupMode && (
                            <DisplayListUI
                                items={self.state.users ?? []}
                                classForListContainer="tabName-clickableText-results"
                                onSelectedItemCallback={item => self.onClickUser(item.Model)}
                                includeSearchbox={true}
                                renderItem={item => (
                                    <div>{item.Model.NameWithPrefix}</div>
                                )}
                                classForItem="displayList-search-item"
                            />
                        )}
                        {self.props.isGroupMode && (
                            <DisplayListUI
                                items={self.state.groups ?? []}
                                classForListContainer="tabName-clickableText-results"
                                onSelectedItemCallback={item => self.onClickGroup(item.Model)}
                                includeSearchbox={true}
                                renderItem={item => (
                                    <div>{item.Model.Name}</div>
                                )}
                                classForItem="displayList-search-item"
                            />
                        )}
                    </div>
                    {/* Tabs */}
                    <div style={{ width: "25%", float: "left", height: "415px" }}>
                        <div style={{ textAlign: "center", padding: "5px 0px", borderBottom: " solid 1px rgb(214, 209, 209)" }}>
                            <h5>{cacheStore.GetString("TabLabel")}</h5>
                        </div>
                        {(self.state.textList != null && self.state.textList.length > 0) && (
                            <DisplayListUI
                                items={self.state.textList ?? []}
                                classForListContainer="tabName-clickableText-results"
                                onSelectedItemCallback={item => self.onClickTabs(item.Model)}
                                includeSearchbox={true}
                                renderItem={item => (
                                    <div style={{ justifyContent: "flex-start", width: "100%" }}>
                                        <div style={{ paddingRight: "5px" }}>
                                            <CheckboxControl
                                                checked={item.Model.IsChecked}
                                                label={item.Model.TabName}
                                                onChange={() => self.props.textListCallback(item)}
                                                labelStyle={{ cursor: "pointer", fontWeight: "bold" }}
                                            />
                                        </div>
                                    </div>
                                )}
                                classForItem="displayList-search-item"
                            />
                        )}
                    </div>

                    {/* Details */}
                    <div style={{ width: "50%", float: "left", height: "415px" }}>
                        <div style={{ textAlign: "center", padding: "5px 0px", borderBottom: " solid 1px rgb(214, 209, 209)" }}>
                            <h5>{cacheStore.GetString("DetailsLabel")}</h5>
                        </div>
                        {(self.state.textList != null && self.state.textList.length > 0 && self.state.clickableContent != null && self.state.clickableContent.length > 0) && (
                            <div className="tabName-clickableText-results" style={{ overflowY: "auto", border: "1px solid rgb(214, 209, 209)", marginTop: "50px" }}>
                                <div className="preview">
                                    <div className="preview-container">
                                        <div className="overflow-control" style={{ whiteSpace: "pre" }}>
                                            <ul className="clickable-text-list">
                                                {self.state.clickableContent.map((s: string, idx: number) => (
                                                    <li key={idx + "___cli"} style={{ flexWrap: "wrap" }}>
                                                        <div className="flex-container" style={{ justifyContent: "flex-start", display: "flex", marginLeft: "5px" }}>
                                                            <div style={{ width: "10px" }}>
                                                                <span className="dot" />
                                                            </div>
                                                            <div style={{ width: "10px" }}>
                                                                {this.splitClickableTextItems(s).map((sp: string, idx2: number) => (
                                                                    <a key={"individual_link_" + idx2} style={{ marginRight: "5px", lineHeight: "15px", minHeight: "35px", marginBottom: "6px", textDecoration: "underline" }}>
                                                                        <span>{sp}</span>
                                                                    </a>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {(self.state.textList != null && self.state.textList.length > 0 && self.state.isShowDetails && self.state.clickableContent.length == 0) && (
                            <div className="tabName-clickableText-results" style={{ overflowY: "auto", border: "1px solid rgb(214, 209, 209)", marginTop: "50px" }}>
                                <div className="pointer" style={{ textAlign: "center" }}>
                                    <span>{cacheStore.GetString("TextIsEmptyLabel")}</span>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        );
    }

    private mutateState(mutation: (s: ClickableTextUsersComponentState) => void, then: () => void = null): void {
        var s = new ClickableTextUsersComponentState();
        mutation(s);
        this.setState(s, then);
    }

    private onClickUser(item: Person): void {
        this.mutateState(
            s => {
                s.textList = [];
                s.clickableContent = [];
                s.isShowDetails = false;
            },
            () => {
                sessionStore.dispatch(LocalOperations.AdministrationUsers.GetAllClickableTectFromSpecificUserForSpecificContext, { SelectedItem: item });
            }
        );
    }

    private onClickGroup(item: EmployeeGroup): void {
        this.mutateState(
            s => {
                s.textList = [];
                s.clickableContent = [];
                s.isShowDetails = false;
            },
            () => {
                sessionStore.dispatch(LocalOperations.AdministrationGroup.GetAllClickableTectFromSpecificGroupForSpecificContext, { SelectedItem: item });
            }
        );
    }

    private onClickTabs(x: ClickableTextItem): void {
        let self = this;
        let content = x.ClickableContent;
        self.mutateState(s => {
            s.clickableContent = [];
            // if (x.ClickableContentItems != null && x.ClickableContentItems.length > 0) {
            //    for (let content of x.ClickableContentItems) {
            //        s.clickableContent.push.apply(s.clickableContent, this.parseClickableRow(content));
            //    }
            // }
            s.clickableContent = this.parseClickableContent(content);
            s.isShowDetails = true;
        });
    }

    private parseClickableContent(str: string): string[] {
        if (IsNullOrWhiteSpace(str))
            return [];

        let pattern = new RegExp("/\\*(((?!\\*/)[\\S\\s])*)\\*/", "g");

        let matchRanges: string[] = [];
        let result: RegExpExecArray = null;
        while ((result = pattern.exec(str)) !== null) {
            matchRanges.push(result[1]);
        }

        return matchRanges.filter(x => !IsNullOrWhiteSpace(x));
    }

    private splitClickableTextItems(txt: string): string[] {
        if (IsNullOrWhiteSpace(txt))
            return [];

        return txt.split(";").filter(s => !IsNullOrWhiteSpace(s));
    }
}

export { ClickableTextUsersComponent };
